import { AuthFetch, AuthFetchForm } from "../hooks/useApi";
import { TemplateUploadResponse, TemplateFileNameResponse } from "../types/template.types";

export const templateService = {

  upload: (
    apiFetchForm: AuthFetchForm,
    folder: string,
    email: string,
    file: File,
  ): Promise<TemplateUploadResponse> => {
    const formData = new FormData();
    formData.append("template_file", file);
    return apiFetchForm<TemplateUploadResponse>(
      `/templates/${encodeURIComponent(folder)}/${encodeURIComponent(email)}`,
      formData,
    );
  },

  getFileName: (
    apiFetch: AuthFetch,
    folder: string,
    email: string,
  ): Promise<TemplateFileNameResponse> =>
    apiFetch<TemplateFileNameResponse>(
      `/templates/${encodeURIComponent(folder)}/${encodeURIComponent(email)}`,
      { method: "GET" },
    ),
};
